import PropTypes from 'prop-types';
import React from 'react';
import './student-name-with-avatar.scss';
import styled from 'styled-components';
import AvatarRenderer from '../../../../common/AvatarRenderer/AvatarRenderer';
import getStudentTeamIcons from '../../../getStudentTeamIcons';
import { useStudentListContext } from '../../StudentListContext';

export const StudentNameWithAvatar = ({
  avatar,
  studentName,
  studentUsername,
  studentId,
}) => {
  const { teamsData } = useStudentListContext();
  return (
    <div className="student-info usprivacy" data-recording-sensitive>
      <span
        data-testid={`avatar-${studentUsername}`}
        className="student-info__avatar"
      >
        <AvatarRenderer src={avatar} size={24} />
      </span>
      <span
        className="student-info__name usprivacy"
        data-html={true}
        data-tip={
          studentUsername
            ? `<div class="usprivacy" data-recording-sensitive>${studentName} - ${studentUsername}</div>`
            : ''
        }
        data-testid="student-name"
        dir={'ltr'}
      >
        {studentName}
      </span>
      <div className="student-info__team_icon_wrapper">
        {getStudentTeamIcons(teamsData, studentId).map(({ icon, name }) => (
          <TeamIcon
            data-tip={name}
            data-testid={`team-icon--${icon}`}
            key={icon}
            className={`assignments-icon ${icon} colored`}
          />
        ))}
      </div>
    </div>
  );
};

StudentNameWithAvatar.defaultProps = {
  avatar: '',
};

StudentNameWithAvatar.propTypes = {
  avatar: PropTypes.string,
  studentName: PropTypes.string.isRequired,
  studentUsername: PropTypes.string.isRequired,
  studentId: PropTypes.string.isRequired,
};

export const TeamIcon = styled.i`
  margin: 0px 5px;
`;
